<template>
    <div class="newsletter-signup">
        <form v-if="!form.sent" @submit.prevent="recaptcha" class="d-flex flex-column flex-sm-row gap-2 justify-content-center">
            <label for="newsletter-email" class="visually-hidden">Email address</label>
            <input type="email" id="newsletter-email" class="form-control" style="max-width: 320px;"
                placeholder="Your work email" v-model="form.email" required>
            <button type="submit" class="btn btn-primary rounded-5 px-4" :disabled="submitting">
                {{ submitting ? 'Subscribing…' : 'Subscribe' }}
            </button>
        </form>
        <div v-else class="fw-600">
            You're subscribed. Watch your inbox for practical IT &amp; security insights.
        </div>
    </div>
</template>

<script>
import { useReCaptcha } from "vue-recaptcha-v3";
import { reactive, ref } from "vue";

export default {
    setup() {
        const form = reactive({
            email: '',
            captcha_token: '',
            sent: false,
        })
        const submitting = ref(false)

        const { executeRecaptcha, recaptchaLoaded } = useReCaptcha()
        const recaptcha = async () => {
            submitting.value = true
            await recaptchaLoaded()
            form.captcha_token = await executeRecaptcha('newsletter')
            submit()
        }

        function submit() {
            axios.post('/api/newsletter', form).then(() => {
                form.sent = true
                if (typeof window !== 'undefined') {
                    import('vue-gtag').then(({ event }) => event('newsletter_signup', { method: 'Footer' }))
                }
            }).catch(() => {
                // keep the form visible so the visitor can retry
            }).then(() => {
                submitting.value = false
            })
        }

        return {
            form,
            submitting,
            recaptcha,
        }
    },
}
</script>
